import * as _ from "lodash";
import "./index.scss";
import { getImageUrl } from "../../../utils/image";
import { SessionStatus } from "../../../constant/enums";

const ChatBadgeHeader = ({
  session,
  profile,
  isOpenRating,
  onRating,
  isShowHeader,
}) => {
  const { imageUrl } = profile;
  const title = _.get(profile, "companyName", "");
  const status = _.get(session, "status", SessionStatus.NEW);

  const baseStyle = {
    color: "black",
    display: isShowHeader ? "flex" : "none",
  };

  return (
    <div className="header-bot" style={baseStyle}>
      <div className="d-flex align-items-center gap-2">
        <div className="logo">
          <img
            src={getImageUrl(imageUrl)}
            alt="Avatar"
            style={{
              width: 50,
              height: 51,
              borderRadius: 8,
              objectFit: "cover",
              marginRight: 12,
            }}
          />
        </div>
        <div className="title">
          <strong>{title}</strong>
        </div>
      </div>
      {status === SessionStatus.PENDING && (
        <button
          style={{ background: "none", border: "none" }}
          className="widgetChatLike"
          onClick={() => {
            if (onRating) {
              onRating(!!!isOpenRating);
            }
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.31572 8.33268H3.33329C2.41207 8.33268 1.66663 9.07812 1.66663 9.99935V16.666C1.66663 17.5872 2.41207 18.3327 3.33329 18.3327H12.9166C13.916 18.3327 14.8339 17.7337 15.1985 16.8418L18.1152 11.0085L18.1412 10.9596C18.6718 9.68359 18.0664 8.222 16.7903 7.69141C16.4876 7.56445 16.1621 7.49935 15.8333 7.49935H11.6666V3.33268C11.6666 2.41471 10.9179 1.66602 9.99996 1.66602H9.88512C9.12757 1.66602 8.43505 2.09402 8.09626 2.77159L5.31572 8.33268ZM6.66663 9.36784L9.63027 3.44056C9.66332 3.37444 9.7309 3.33268 9.80481 3.33268C9.91259 3.33268 9.99996 3.42005 9.99996 3.52783V9.16602H15.8333C16.2923 9.16602 16.6666 9.54036 16.6634 10.0026C16.6634 10.1035 16.6438 10.2044 16.608 10.2988L13.6914 16.1484C13.5612 16.4609 13.2552 16.666 12.9166 16.666H6.66663V9.36784ZM4.99996 9.99935V16.666H3.33329V9.99935H4.99996Z"
              fill="#677187"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ChatBadgeHeader;
